import Content from "uxp-documentation/src/pages/uxp-api/reference-css/General/units";
import * as React from 'react';
export default {
  Content,
  React
};